const colorSchemes = {
  light: {
    palette: {
      background: {
        default: '#F7F7F7',
        paper: '#FBFBFB',
        dark: '#EFEFEF',
      },
      action: {
        active: '#6F6F6F',
        hover: '#EFEFEF',
        selected: '#E4EEF7',
        disabled: '#00000061',
        focus: '#0000001F',
      },
      color1: 'rgba(255,0,192,1)',
      color2: 'rgba(255,109,21,1)',
      customMain: 'linear-gradient(90deg, var(--mui-palette-color1) 0%, var(--mui-palette-color2) 90%)',
      border: '#C4C4C4',
      divider: '#0000001F',
      error: {
        main: '#D32F2F',
        dark: '#C62828',
        light: '#EF5350',
        contrastText: '#FFFFFF',
      },
      info: {
        main: '#0288D1',
        dark: '#01579B',
        light: '#03A9F4',
        contrastText: '#FFFFFF',
      },
      primary: {
        main: '#1976D2',
        dark: '#1565C0',
        light: '#42A5F5',
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: '#FF7700',
        dark: '#E65100',
        light: '#FF9800',
      },
      success: {
        main: '#2E7D32',
        dark: '#1B5E20',
        light: '#4CAF50',
        contrastText: '#FFFFFF',
      },
      text: {
        primary: '#000000DE',
        secondary: '#000000A6',
        disabled: '#00000061',
      },
      warning: {
        main: '#ED6C02',
        dark: '#E65100',
        light: '#FF9800',
        contrastText: '#FFFFFF',
      },
      DataGrid: {
        bg: '#FBFBFB',
        pinnedBg: '#FBFBFB',
        headerBg: '#FBFBFB',
      },
    },
  },
  dark: {
    palette: {
      background: {
        default: '#1D1E1F',
        paper: '#111416',
        dark: '#000000',
      },
      action: {
        active: '#FFFFFFF2',
        hover: '#363739',
        selected: '#242D3C',
        disabled: '#FFFFFF61',
        focus: '#0000001F',
      },
      color1: 'rgba(255,0,192,1)',
      color2: 'rgba(255,109,21,1)',
      customMain: 'linear-gradient(90deg, var(--mui-palette-color1) 0%, var(--mui-palette-color2) 90%)',
      border: '#6C6C6C',
      divider: '#FFFFFF1F',
      error: {
        main: '#DD4848',
        dark: '#C62828',
        light: '#EF5350',
        contrastText: '#000000',
      },
      info: {
        main: '#0e9ae6',
        dark: '#01579B',
        light: '#03A9F4',
        contrastText: '#000000',
      },
      primary: {
        main: '#4D97E0',
        dark: '#1565C0',
        light: '#42A5F5',
        contrastText: '#111416',
      },
      secondary: {
        main: '#FBA254',
        dark: '#E65100',
        light: '#FF9800',
      },
      success: {
        main: '#2E7D32',
        dark: '#1B5E20',
        light: '#4CAF50',
        contrastText: '#000000',
      },
      text: {
        primary: '#f6f6f6',
        secondary: '#FFFFFFA6',
        disabled: '#FFFFFF61',
      },
      DataGrid: {
        bg: '#111416',
        headerBg: '#111416',
        pinnedBg: '#111416',
      },
      warning: {
        main: '#ED6C02',
        dark: '#E65100',
        light: '#FF9800',
        contrastText: '#000000',
      },
    },
  },
};

export default colorSchemes;